import AppRecord from './AppRecord.js'

class AifCommitmentTransaction extends AppRecord {
}

export default AifCommitmentTransaction
